import { DocumentLink } from '../../Types';

export const mapAttachmentToDocumentLink = (requestId: number, { name }): DocumentLink => {
    const identifier = encodeURIComponent(name);

    return {
        title: name,
        link: `${API_ROOT}/requests/${requestId}/attachments/${identifier}`,
        identifier,
    };
};
